import { object, string } from 'yup';
import { EuroValue } from '../../common';

export type IOptionalService = {
  id: string;
  label: string;
  amountPerMonth: number;
  amountPerDay: number;
};

export type IOptionalServiceCreate = {
  label: string;
  amountPerMonth: number;
  amountPerDay: number;
};

export const IOptionalServiceCreateSchema = object({
  label: string().required(),
  amountPerMonth: EuroValue.required(),
  amountPerDay: EuroValue.required(),
});

export type IOptionalServiceUpdate = {
  label?: string;
  amountPerMonth?: number;
  amountPerDay?: number;
};

export const IOptionalServiceUpdateSchema = object({
  label: string().optional().default(undefined),
  amountPerMonth: EuroValue.optional().default(undefined),
  amountPerDay: EuroValue.optional().default(undefined),
});
